import { createContextLocalStore } from 'stores/local/createContextLocalStore';

import { CreateMeetingDrawerModal } from './CreateMeetingDrawerModal';

const { Provider, useStore } = createContextLocalStore(CreateMeetingDrawerModal);

export {
  Provider as CreateMeetingDrawerModalProvider,
  useStore as useCreateMeetingDrawerModal,
  CreateMeetingDrawerModal,
};
